import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from 'react';
import { FormSelect, RadioGroup, RadioGroupDataInterface } from '@systemeio/ui';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { usePageForms } from 'modules/automation-rules/triggers/hooks/use-page-forms';
import { AutomationRuleErrorInterface } from 'modules/automation-rules/types/automation-rule-interface';
import { twMerge } from 'tailwind-merge';
import { AutomationRuleTriggersDataEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
enum TriggerFormPageTypeEnum {
  Field = 'field',
  Form = 'form',
}
interface TriggerFormItemProps {
  pageId: number | undefined;
  form: {
    id: string;
    name: string;
  } | null | undefined;
  onFormChange: (form: {
    id: string;
    name: string;
  } | null) => void;
  onOpen: (slug: AutomationRuleTriggersDataEnum) => void;
  isStatic?: boolean;
  errors: AutomationRuleErrorInterface;
  triggerId: number;
  renderTriggerLabel: (props: {
    label: string;
  }) => JSX.Element;
}
export const TriggerFormItem = t0 => {
  const $ = _c(46);
  const {
    pageId,
    form,
    onFormChange,
    onOpen,
    isStatic,
    errors,
    triggerId,
    renderTriggerLabel
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [value, setValue] = useState(form?.id ? TriggerFormPageTypeEnum.Form : TriggerFormPageTypeEnum.Field);
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.automation_rule.form_field");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      id: TriggerFormPageTypeEnum.Field,
      caption: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("dashboard.automation_rule.form_element");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("global.label_new");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <span className="text-green border-green rounded-md border px-1.5">{t4}</span>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = {
      id: TriggerFormPageTypeEnum.Form,
      caption: t3,
      additionalInfo: t5
    };
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t2 || $[14] !== t6) {
    t7 = [t2, t6];
    $[13] = t2;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const formPageTypeData = t7;
  const {
    pageFormData,
    isPageFormListLoading
  } = usePageForms(pageId, value === TriggerFormPageTypeEnum.Form);
  let t8;
  let t9;
  if ($[16] !== form) {
    t8 = () => {
      setValue(form ? TriggerFormPageTypeEnum.Form : TriggerFormPageTypeEnum.Field);
    };
    t9 = [form];
    $[16] = form;
    $[17] = t8;
    $[18] = t9;
  } else {
    t8 = $[17];
    t9 = $[18];
  }
  useEffect(t8, t9);
  const t10 = isPageFormListLoading && value === TriggerFormPageTypeEnum.Form && "bg-skeleton-primary/40 animate-pulse";
  let t11;
  if ($[19] !== t10) {
    t11 = twMerge("bg-background-primary/50 rounded-t-xl", t10);
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== form || $[22] !== onFormChange) {
    t12 = data => {
      setValue(data as TriggerFormPageTypeEnum);
      if (data === TriggerFormPageTypeEnum.Field && form !== null) {
        onFormChange(null);
      }
    };
    $[21] = form;
    $[22] = onFormChange;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== formPageTypeData || $[25] !== isPageFormListLoading || $[26] !== t11 || $[27] !== t12 || $[28] !== value) {
    t13 = <RadioGroup disabled={isPageFormListLoading} optionWrapperClassName="p-2" selectedOptionWrapperClassName={t11} options={formPageTypeData} selected={value} onChange={t12} />;
    $[24] = formPageTypeData;
    $[25] = isPageFormListLoading;
    $[26] = t11;
    $[27] = t12;
    $[28] = value;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== errors || $[31] !== form?.id || $[32] !== form?.name || $[33] !== isPageFormListLoading || $[34] !== isStatic || $[35] !== onFormChange || $[36] !== onOpen || $[37] !== pageFormData || $[38] !== renderTriggerLabel || $[39] !== t || $[40] !== triggerId || $[41] !== value) {
    t14 = value === TriggerFormPageTypeEnum.Form ? <div>{isPageFormListLoading ? <FormElementSkeleton /> : <div className="bg-background-primary/50 text-text-primary rounded-b-xl rounded-r-xl p-3">{pageFormData?.length !== 0 ? <><p className="text-text-primary mb-2">{t("dashboard.automation_rule.trigger_via_form_element_description")}</p><FormSelect disabled={isStatic || isPageFormListLoading} onOpen={() => onOpen(AutomationRuleTriggersDataEnum.form_subscribed_element_page)} value={form?.id} staticData={[{
            id: form?.id ?? "",
            caption: form?.name ?? ""
          }]} data={pageFormData} onChange={formId => {
            if (!formId) {
              return;
            }
            const selectedForm = pageFormData?.find(f => f.id === formId);
            onFormChange({
              id: formId,
              name: selectedForm?.caption ?? ""
            });
          }} label={renderTriggerLabel({
            label: t("dashboard.automation_rule.form_element_title")
          })} placeholder={t("dashboard.automation_rule.form_element_placeholder")} error={errors.automationTriggers[triggerId]?.formId?.join("")} withoutCloseIcon={true} /></> : <p className="text-text-primary">{t("dashboard.automation_rule.form_elemant_list_empty")}</p>}</div>}</div> : <div className="bg-background-primary/50 mt-[-2px] rounded-b-xl rounded-r-xl p-3"><p className="text-text-primary">{t("dashboard.automation_rule.trigger_via_field_form_description")}</p></div>;
    $[30] = errors;
    $[31] = form?.id;
    $[32] = form?.name;
    $[33] = isPageFormListLoading;
    $[34] = isStatic;
    $[35] = onFormChange;
    $[36] = onOpen;
    $[37] = pageFormData;
    $[38] = renderTriggerLabel;
    $[39] = t;
    $[40] = triggerId;
    $[41] = value;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] !== t13 || $[44] !== t14) {
    t15 = <div>{t13}{t14}</div>;
    $[43] = t13;
    $[44] = t14;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  return t15;
};
const FormElementSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="bg-skeleton-primary/40 h-[70px] w-full animate-pulse rounded-b-xl rounded-r-xl" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};